/* ================================================== */
/* MOBILE MENU → Close
/* ================================================== */

function closeMenu() {

	// Hide menu
	$menu.removeClass(openClass);
	$menuTrigger.removeClass(activeClass.substr(1));

	// Enable other mobile menu links
	$('ul > li:not(:first-child) > a', $menuMobile).attr('tabindex', '0');

	// Reset menu attributes
	$menu.removeAttr(openClass).attr({
		'aria-hidden'  : 'true',
		'aria-expanded': 'false'
	});

	// Reset focus on menu links
	$('a', $menu).attr('tabindex', '-1').blur();

	// Set unfocusable elements focusable
	$('html, body').removeClass('overflow-hidden');
	$('body').attr('data-menu', 'closed');
	$('body > *:not(.menu--trigger):not(.menu--header)').find('a, button, details > summary, iframe').each(function(index, element) {
		var tabindex = $(element).attr('data-initial-tabindex');
		if (typeof tabindex !== typeof undefined && tabindex !== false) {
			$(element).attr('tabindex', tabindex);
		} else {
			$(element).removeAttr('tabindex data-initial-tabindex');
		}
	});

	// Set focus back to element that triggered menu
	if (typeof lastFocusedElement !== 'undefined' && lastFocusedElement !== false && lastFocusedElement !== null) {
		lastFocusedElement.focus();
	}

}